// @flow

export const emptySelection = {
	name: null,
	label: 'None',
	colors: 'secondaryflat',
};

export default {};
